import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddCheckListLawsuitQst from "./addCheckListLawsuitQst";
import { report } from "process";
const MySwal = withReactContent(Swal2);

const AdminPanelReportClients = (props) => {
  const [letters, setLetters] = useState([]);
  const [reports, setReports] = useState([]);
  const [user, setUser] = useState("");
  const [edit, setEdit] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchLetters = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLetters(data);
        fetchReports();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const fetchReports = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setReports(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getData = () => {
    setLoading(true);
    setUser("");
    fetchLetters();
  };

  useEffect(() => {
    getData();
  }, []);

  const sendFiles = async (e) => {
    setLoading(true);

    var body = {
      name: user,
      mail: letters.filter((el) => el.name === user)[0].mail,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "odbiorcę",
        }).then((result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const deleteFiles = async (e) => {
    setLoading(true);

    var body = {
      id: e.target.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteClientReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Usunięto",
          text: "odbiorcę",
        }).then((result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  return (
    <>
      <div className="mainContainerPayments">
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            {true ? (
              <>
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    marginBottom: "2vh",
                  }}
                >
                  <div style={{ width: "45%", textAlign: "left" }}>
                    <p
                      style={{
                        margin: "0",
                        marginBottom: "1px",
                        fontWeight: "600",
                        fontSize: ".8vw",
                        paddingLeft: "20px",
                      }}
                    >
                      nazwa
                    </p>
                    <select
                      type="text"
                      style={{
                        height: "3vh",
                        width: "100%",
                        padding: "0px 10px",
                        boxSizing: "border-box",
                        height: "3vh",
                      }}
                      value={user}
                      onChange={(e) => setUser(e.target.value)}
                    >
                      {!user ? (
                        <>
                          <option key={0} value={0}>
                            {"Wybierz..."}
                          </option>
                        </>
                      ) : (
                        ""
                      )}
                      {letters.map((el) => (
                        <>
                          <option key={el.id} value={el.name}>
                            {el.name}
                          </option>
                        </>
                      ))}
                    </select>
                  </div>
                </div>

                <div
                  style={{
                    marginBottom: "5vh",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#00bdce",
                      border: "none",
                      color: "white",
                      fontWeight: "600",
                      borderRadius: "15px",
                    }}
                    id="clientsFilterButton"
                    className="paymentMenuButton"
                    onClick={sendFiles}
                  >
                    Dodaj
                  </button>
                </div>
              </>
            ) : (
              ""
            )}
            {reports.length === 0 ? (
              "BRAK ODBIORCÓW RAPORTÓW"
            ) : (
              <>
                {reports.map((el, index) => (
                  <>
                    <div
                      style={{
                        width: "80%",
                        padding: "3vh 1vw",
                        backgroundColor: "lightgray",
                        borderRadius: "15px",
                        fontSize: "1vw",
                        display: "flex",
                        alignItems: "center",
                        marginTop: "1vh",
                      }}
                    >
                      <div style={{ width: "40%" }}>Nazwa: {el.name}</div>
                      <div style={{ width: "40%" }}>Mail: {el.mail}</div>
                      <div
                        style={{ width: "20%", display: "flex", gap: "10px" }}
                      >
                        {true ? (
                          <button
                            style={{
                              backgroundColor: "white",
                              border: "none",
                              color: "black",
                              fontWeight: "600",
                              borderRadius: "15px",
                            }}
                            id="clientsFilterButton"
                            className="paymentMenuButton"
                            value={el.id}
                            onClick={deleteFiles}
                          >
                            Usuń
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </>
                ))}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanelReportClients;
